// App icon badge resync (pending reservation requests). The server pushes the
// count, and the OS applies it even with the app closed; this corrects it
// whenever the app is open, and lets the app cancel notifications of requests
// that are no longer pending. Best-effort, only on app builds that have the
// handler (an older build would leave the request hanging), and only on change.
export const createBadgeSetter = (
  request: (pendingRequestIds: string[]) => Promise<void>,
  supported: () => boolean,
) => {
  let last: string | null = null;
  return {
    async set(pendingRequestIds: string[]) {
      const key = [...pendingRequestIds].sort().join(",");
      if (!supported() || key === last) return;
      last = key;
      try {
        await request(pendingRequestIds);
      } catch (error) {
        last = null;
        console.warn("Failed to set badge:", error);
      }
    },
    // Native clears the badge and the request notifications itself on logout.
    cleared() {
      last = "";
    },
  };
};
